module.exports = "<wor-haynes-pro-lookup-settings\n  [settings]=\"settings\">\n</wor-haynes-pro-lookup-settings>\n";